var Request = require("./helper/request");

function Domain(app){
	var self = this;
	self.app = app;
	self.request = new Request(app);

	self.routes = {
		show: {
			url: "/domain/:domain",
			method: "GET"
		}
	};
}

Domain.prototype.show = function(domain){
	var self = this;
	var uri = self.routes.show.url.replace(":domain", domain);
	return self.request.get(uri);
}

module.exports = Domain;